import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { NoteComponentBase } from './note-component-base.js';

export class ClientNoteComponent extends NoteComponentBase {
  static readonly TYPE_ID: string = '3b5acfa6d67d411487a3227653a549fa';

  constructor(
      note: string,
  ) {
    super(note);
  }

  get $typeId(): string {
    return ClientNoteComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ClientNoteComponent {
    return new ClientNoteComponent(
        MapUtils.get<string>(map, 'note'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'note': this.note,
    };
  }

  clone(): this {
    return new ClientNoteComponent(this.note) as this;
  }

  isSame(other: ClientNoteComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.note === this.note;
  }
}

export class ClientNoteComponentBuilder extends DataModelBuilder<ClientNoteComponent> {
  build(context: SerializationContext, map: SerializedData): ClientNoteComponent {
    return ClientNoteComponent.fromMap(context, map);
  }
}
